import * as React from "react";
import * as moment from "moment";
import { actionCreators } from "page/calendar/store";
import { actionCreators as uiActionCreators } from "ui/store";
import * as cn from "classnames/bind";
import * as styles from "./summary-controls.css";
import { CalendarState } from "burde";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { NavigationComponent } from "ui/constants";
import { CalendarType } from "svg/constants";
import { useEffect, useState } from "react";
import { useResources } from "contexts/resource-context";
import { useConfiguration } from "contexts/configuration-context";

const cx = cn.bind(styles);

const overviewGroupCn = () =>
    cx({
        orderOverview: true,
    });

const h16Cn = () =>
    cx({
        font16: true,
    });

const pCn = () =>
    cx({
        p: true,
    });

const detailsListCn = () =>
    cx({
        detailsList: true,
    });

const priceTotalCn = () =>
    cx({
        priceTotal: true,
    });

const aTagCn = () =>
    cx({
        aTag: true,
    });

type SelectedPropertyItem = {
    Name: string;
    Value: string;
};

type SummaryControlsAccordionProps = {
    Summary_StartDate: string;
    Summary_Header: string;
    Summary_Lead_Link: string;
    Summary_Lead_Part1: string;
    Summary_Lead_Bold: string;
    Summary_Lead_Part2: string;
    Summary_TotalPrice: string;
    Summary_TaxAndShipping: string;
    Product_Price_Format: string;
    calendar: CalendarState;
    activeComponent: NavigationComponent;
} & typeof actionCreators &
    typeof uiActionCreators;

const SummaryControlsAccordion: React.FC<
    SummaryControlsAccordionProps & RouteComponentProps
> = (props) => {
    const resources = useResources();

    const { displayPrice = "" } = useConfiguration();

    const getSelectedProperties = () => {
        const { calendar } = props;

        let propsList: Array<SelectedPropertyItem> = [];

        let startDate = moment(calendar.startDate).format("MMMM YYYY");
        let startDateString =
            startDate.charAt(0).toUpperCase() + startDate.slice(1);

        propsList.push({
            Name: resources["Summary_StartDate"],
            Value: startDateString,
        });

        return propsList;
    };

    return (
        <>
            <div className={overviewGroupCn()}>
                <h6 className={h16Cn()}>{resources["Summary_Header"]}</h6>
                <p className={pCn()}>
                    <a
                        className={aTagCn()}
                        onClick={() => {
                            props.UpdateShowMainMenu(true);
                        }}>
                        {resources["Summary_Lead_Link"]}
                    </a>{" "}
                    {resources["Summary_Lead_Part1"]}
                    <br />
                    <strong>{resources["Summary_Lead_Bold"]}</strong>{" "}
                    {resources["Summary_Lead_Part2"]}{" "}
                </p>
                {props.calendar.calendarType !== CalendarType.Notebook && (
                    <ul className={detailsListCn()}>
                        {getSelectedProperties().map((prop, index) => (
                            <li key={prop.Name + index}>
                                <div style={{ fontWeight: "bold" }}>
                                    {prop.Name}
                                </div>
                                <div style={{ fontSize: "18px" }}>
                                    {prop.Value}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                <div className={priceTotalCn()}>
                    <span>{resources["Summary_TotalPrice"]}</span>
                    <strong>{displayPrice}</strong>
                    <span>{resources["Summary_TaxAndShipping"]}</span>
                </div>
            </div>
        </>
    );
};
export default withRouter(SummaryControlsAccordion);
